export type Environment = {
  configured: null | {
    workspaceId: string;
    repositoryId: string | null;
    workspaceName: string;
    repositoryName: string | null;
    branchName: string | null;
    type?: string;
    workspaceMode?: "isolated" | "machine";
    machine?: {
      git?: {
        available: boolean;
        executableAvailable?: boolean;
        repository?: boolean;
        worktree: boolean;
        supported?: boolean;
        branch: string | null;
        dirty: boolean | null;
      } | null;
    } | null;
  };
  configurations?: Array<{
    workspaceId: string;
    workspaceName: string;
    repositoryId: string;
    repositoryName: string;
    branchName: string | null;
  }>;
  templates?: Array<{
    id: string;
    slug: string;
    name: string;
    description: string | null;
    type?: string;
    workspaceMode?: "isolated" | "machine";
    machine?: {
      folderName?: string;
      git?: {
        available: boolean;
        executableAvailable?: boolean;
        repository?: boolean;
        worktree: boolean;
        supported?: boolean;
        branch: string | null;
        dirty: boolean | null;
      } | null;
    } | null;
  }>;
};

export type Result = { stdout: string; stderr: string; code: number };
export type DevelopmentSelection = {
  workspaceId?: string | null;
  repositoryId?: string | null;
};
export type ChangedFile = {
  path: string;
  staged: boolean;
  unstaged: boolean;
  code: string;
};
export type FileViewMode = "file" | "inline" | "split";

export function selectionBody(selection: DevelopmentSelection) {
  return {
    ...(selection.workspaceId ? { workspaceId: selection.workspaceId } : {}),
    ...(selection.repositoryId !== undefined
      ? { repositoryId: selection.repositoryId }
      : {}),
  };
}

export function parseStatus(output: string) {
  const records = output.split("\0").filter(Boolean);
  let branch = "";
  if (records[0]?.startsWith("## "))
    branch = records
      .shift()!
      .slice(3)
      .split("...")[0]
      .replace(/^(?:No commits yet on |Initial commit on )/, "");
  const files: ChangedFile[] = [];
  for (let index = 0; index < records.length; index += 1) {
    const row = records[index];
    const code = row.slice(0, 2);
    const path = row.slice(3);
    if (/[RC]/.test(code) && records[index + 1]) index += 1;
    const conflicted = ["DD", "AU", "UD", "UA", "DU", "AA", "UU"].includes(
      code,
    );
    files.push({
      path,
      code,
      staged: !conflicted && code[0] !== " " && code[0] !== "?",
      unstaged: conflicted || code[1] !== " " || code === "??",
    });
  }
  return { branch, files };
}
